module.exports = __webpack_public_path__ + "static/brownbearcomf-8f2046a3271e923fbc5a27f67b1789ce.jpeg";